<template>
    <div class="ssn-number-group">
        <input 
            type="hidden" 
            :name="name"
            :value="value" 
            :disabled="disabled"
        >
        <input 
            type="text" 
            class="form-control" 
            maxlength="3" 
            v-model="a" 
            @keydown="check" 
            :disabled="disabled"
        />
        <input 
            type="text" 
            class="form-control" 
            maxlength="2"
            v-model="b" 
            ref="input2"
            @keydown="check" 
            :disabled="disabled"
        />
        <input 
            type="text" 
            class="form-control" 
            maxlength="4"
            v-model="c" 
            ref="input3"
            @keydown="check" 
            :disabled="disabled"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            required: true
        },
        defaultValue: {
            default: ''
        },
        disabled: {
            default: false
        }
    },
    computed: {
        value() {
            return `${this.a || ''} ${this.b || ''} ${this.c || ''}`;
        }
    },
    data() {
        return {
            a: '',
            b: '',
            c: '',
            bootstrap: true
        }
    },
    mounted() {
        // set up the default value of the widget
        if (this.defaultValue) {
            var matches = this.defaultValue.match(/(\S\S\S)-(\S\S)-(\S\S\S\S)/);
            if(matches) {
                this.a = matches[0];
                this.b = matches[1];
                this.c = matches[2];
            }
        }
        
        // we don't want to focus any elements on page load
        // so we use the bootstrap property to signal whether
        // this is the first load, or later
        this.$nextTick(() => {
            this.bootstrap = false
        })
    },
    methods: {
        check(event) {
            // we want to prevent all keystrokes that are
            // non-numbers and that are not 'meta' keys
            // like shift, control, etc.
            if (
                event.key.length === 1
                && event.key.match(/[^0-9]/)
                && !event.metaKey
            ) {
                event.preventDefault()
            }
        }
    },
    watch: {
        a(a,b) {
            if(a && a.length === 3 && !this.bootstrap) {
                this.$refs.input2.focus();
            }
        },
        b(a,b) {
            if(a && a.length === 2 && !this.bootstrap) {
                this.$refs.input3.focus();
            }
        }
    }
}
</script>
